
// Tipos de autenticación
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const START_SESSION = "START_SESSION";
export const END_SESSION = "END_SESSION";
